"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSuggestionsOptions = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Suggestion_1 = require("../Suggestion");
var SuggestionHeader_1 = require("../SuggestionHeader");
var SearchBox_st_css_1 = require("./SearchBox.st.css");
function prepareOptionsForDisplay(options, group) {
    var suggestionOptionIdsMap = new Map();
    var _a = group || { baseIndex: 0 }, baseIndex = _a.baseIndex, optionsGroupData = tslib_1.__rest(_a, ["baseIndex"]);
    var preparedOptions = options.map(function (suggestion, index) {
        var globalIndex = baseIndex + index;
        suggestionOptionIdsMap.set("" + globalIndex, tslib_1.__assign({ type: "Option" /* Option */, suggestion: suggestion,
            globalIndex: globalIndex }, optionsGroupData));
        return {
            id: globalIndex,
            isDisabled: false,
            isSelectable: true,
            value: suggestion.title,
            render: function () {
                return (React.createElement("a", { className: SearchBox_st_css_1.st(SearchBox_st_css_1.classes['suggestion-item-link']), title: suggestion.title, href: suggestion.url },
                    React.createElement(Suggestion_1.Suggestion, { key: index, thumbnailWidth: 66, className: SearchBox_st_css_1.st(SearchBox_st_css_1.classes['suggestion-item']), item: {
                            image: suggestion.image,
                            title: suggestion.title,
                            description: suggestion.description,
                        } })));
            },
        };
    });
    return {
        options: preparedOptions,
        suggestionOptionIdsMap: suggestionOptionIdsMap,
    };
}
function getOptionsFromGroups(groups, showAllText) {
    return groups.reduce(function (acc, group, groupIndex) {
        if (!group.options.length) {
            return acc;
        }
        var groupTitleOptionId = "group_" + groupIndex;
        var groupTitleOption = {
            type: "Header" /* Header */,
            group: group,
        };
        var groupTitle = {
            id: groupTitleOptionId,
            isDisabled: false,
            isSelectable: true,
            value: showAllText + " " + group.title,
            render: function () {
                return (React.createElement(SuggestionHeader_1.SuggestionHeader, { title: group.title, url: group.url, showAllText: showAllText }));
            },
        };
        var baseIndex = acc.options.length;
        var preparedOptions = prepareOptionsForDisplay(group.options, {
            baseIndex: baseIndex,
            groupIndex: groupIndex,
            groupId: group.groupId,
        });
        var groupOptions = preparedOptions.options;
        return {
            suggestionOptionIdsMap: new Map(tslib_1.__spread(acc.suggestionOptionIdsMap, [
                [groupTitleOptionId, groupTitleOption]
            ], preparedOptions.suggestionOptionIdsMap)),
            options: tslib_1.__spread(acc.options, [groupTitle], groupOptions),
        };
    }, {
        options: [],
        suggestionOptionIdsMap: new Map(),
    });
}
var mapFederated = {
    item: function (item, id) {
        return {
            id: id,
            isDisabled: false,
            isSelectable: true,
            value: item.title,
            render: function () {
                return (React.createElement("a", { className: SearchBox_st_css_1.st(SearchBox_st_css_1.classes['suggestion-item-link']), title: item.title, href: item.url },
                    React.createElement(Suggestion_1.Suggestion, { key: id, thumbnailWidth: 66, className: SearchBox_st_css_1.st(SearchBox_st_css_1.classes['suggestion-item']), item: {
                            image: item.image || { name: '' },
                            title: item.title,
                            description: item.description || '',
                        } })));
            },
        };
    },
    group: function (item, id, _a) {
        var showAllText = _a.showAllText;
        return {
            id: id,
            isDisabled: false,
            isSelectable: true,
            value: showAllText + " " + item.title,
            render: function () {
                return (React.createElement(SuggestionHeader_1.SuggestionHeader, { title: item.title, url: item.url, showAllText: showAllText }));
            },
        };
    },
};
var getOptionsFromFederatedSuggestions = function (suggestions, showAllText) {
    if (showAllText === void 0) { showAllText = ''; }
    return {
        options: suggestions.items.map(function (item, index) {
            return mapFederated[item.type](item, index, { showAllText: showAllText });
        }),
        suggestionOptionIdsMap: new Map(),
    };
};
function getSuggestionsOptions(props) {
    if (props.suggestions) {
        if ('groups' in props.suggestions) {
            return getOptionsFromGroups(props.suggestions.groups, props.showAllText);
        }
        if ('options' in props.suggestions) {
            return prepareOptionsForDisplay(props.suggestions.options);
        }
        if ('items' in props.suggestions) {
            return getOptionsFromFederatedSuggestions(props.suggestions, props.showAllText);
        }
    }
    return { options: [], suggestionOptionIdsMap: new Map() };
}
exports.getSuggestionsOptions = getSuggestionsOptions;
//# sourceMappingURL=getSuggestionsOptions.js.map